// Components
const LandingPageHeroWhyUsCard = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-hero-why-us-card" */ '@/app/views/client-view/landing-page/components/landing-page-hero-why-us-card/landing-page-hero-why-us-card.vue');

export default {
    name: 'LandingPageHowToGet',
    components: {
        LandingPageHeroWhyUsCard
    },
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() {},
    methods: {},
    // third party libraries
}